/** Значок бабочки для страниц: lucide-react не содержит бабочки, поэтому рисуем свою. */
export function Butterfly({ size = 24 }: { size?: string | number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 7v13" />
    <path d="M12 9C10 4 5 3 3.5 5.5 2.5 8 4 11 8 12c-3 1.5-3.5 4.5-1.5 6 2 1 4-.5 5.5-3" />
    <path d="M12 9c2-5 7-6 8.5-3.5C21.5 8 20 11 16 12c3 1.5 3.5 4.5 1.5 6-2 1-4-.5-5.5-3" />
    <path d="M10.5 4.5 9 2.5M13.5 4.5 15 2.5" />
  </svg>;
}
